/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSystemFormsInternalV2SystemFormsPost } from '../fn/system-forms-internal-v-2/create-system-forms-internal-v-2-system-forms-post';
import { CreateSystemFormsInternalV2SystemFormsPost$Params } from '../fn/system-forms-internal-v-2/create-system-forms-internal-v-2-system-forms-post';
import { createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost } from '../fn/system-forms-internal-v-2/create-system-forms-new-version-internal-v-2-system-forms-form-id-versions-post';
import { CreateSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Params } from '../fn/system-forms-internal-v-2/create-system-forms-new-version-internal-v-2-system-forms-form-id-versions-post';
import { setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch } from '../fn/system-forms-internal-v-2/set-form-version-as-default-internal-v-2-system-forms-form-id-versions-version-id-patch';
import { SetFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Params } from '../fn/system-forms-internal-v-2/set-form-version-as-default-internal-v-2-system-forms-form-id-versions-version-id-patch';
import { SystemForms } from '../models/system-forms';
import { SystemFormsUpdate } from '../models/system-forms-update';
import { SystemFormsVersion } from '../models/system-forms-version';
import { updateSystemFormsInternalV2SystemFormsFormIdPatch } from '../fn/system-forms-internal-v-2/update-system-forms-internal-v-2-system-forms-form-id-patch';
import { UpdateSystemFormsInternalV2SystemFormsFormIdPatch$Params } from '../fn/system-forms-internal-v-2/update-system-forms-internal-v-2-system-forms-form-id-patch';

@Injectable({ providedIn: 'root' })
export class SystemFormsInternalV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createSystemFormsInternalV2SystemFormsPost()` */
  static readonly CreateSystemFormsInternalV2SystemFormsPostPath = '/_internal/v2/system-forms';

  /**
   * Create System Forms.
   *
   * Create a new system form document along with its initial version and associated data.
   *
   * This endpoint creates a new system form record. It first validates that the requesting organization
   * is an agridence member. Then, it creates an initial form version with the provided asset URL and the
   * current timestamp, and associates this version with the new system form document. Finally, it stores
   * the form data in a separate record linked to the form.
   *
   * Args:
   *     system_forms_in (schemas.SystemFormsCreate): The input data required to create the system form.
   *     org (Any): The organization details, used for permission verification.
   *
   * Returns:
   *     schemas.SystemForms: The newly created system form document, including its version information.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSystemFormsInternalV2SystemFormsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSystemFormsInternalV2SystemFormsPost$Response(params: CreateSystemFormsInternalV2SystemFormsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemForms>> {
    return createSystemFormsInternalV2SystemFormsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create System Forms.
   *
   * Create a new system form document along with its initial version and associated data.
   *
   * This endpoint creates a new system form record. It first validates that the requesting organization
   * is an agridence member. Then, it creates an initial form version with the provided asset URL and the
   * current timestamp, and associates this version with the new system form document. Finally, it stores
   * the form data in a separate record linked to the form.
   *
   * Args:
   *     system_forms_in (schemas.SystemFormsCreate): The input data required to create the system form.
   *     org (Any): The organization details, used for permission verification.
   *
   * Returns:
   *     schemas.SystemForms: The newly created system form document, including its version information.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSystemFormsInternalV2SystemFormsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSystemFormsInternalV2SystemFormsPost(params: CreateSystemFormsInternalV2SystemFormsPost$Params, context?: HttpContext): Observable<SystemForms> {
    return this.createSystemFormsInternalV2SystemFormsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemForms>): SystemForms => r.body)
    );
  }

  /** Path part for operation `updateSystemFormsInternalV2SystemFormsFormIdPatch()` */
  static readonly UpdateSystemFormsInternalV2SystemFormsFormIdPatchPath = '/_internal/v2/system-forms/{formId}';

  /**
   * Update System Forms.
   *
   * Update an existing system form document identified by formId.
   *
   * This endpoint updates a system form record with new data. It validates that the requesting organization
   * is an agridence member before proceeding. The system form is retrieved using the provided formId, updated
   * with the new information (including a modified timestamp), and then saved.
   *
   * Args:
   *     system_forms_in (schemas.SystemFormsUpdate): The updated data for the system form.
   *     formId (str): The unique identifier of the system form to update.
   *     org (Any): The organization details for permission validation.
   *
   * Returns:
   *     schemas.SystemFormsUpdate: The updated system form document.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSystemFormsInternalV2SystemFormsFormIdPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSystemFormsInternalV2SystemFormsFormIdPatch$Response(params: UpdateSystemFormsInternalV2SystemFormsFormIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFormsUpdate>> {
    return updateSystemFormsInternalV2SystemFormsFormIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update System Forms.
   *
   * Update an existing system form document identified by formId.
   *
   * This endpoint updates a system form record with new data. It validates that the requesting organization
   * is an agridence member before proceeding. The system form is retrieved using the provided formId, updated
   * with the new information (including a modified timestamp), and then saved.
   *
   * Args:
   *     system_forms_in (schemas.SystemFormsUpdate): The updated data for the system form.
   *     formId (str): The unique identifier of the system form to update.
   *     org (Any): The organization details for permission validation.
   *
   * Returns:
   *     schemas.SystemFormsUpdate: The updated system form document.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSystemFormsInternalV2SystemFormsFormIdPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSystemFormsInternalV2SystemFormsFormIdPatch(params: UpdateSystemFormsInternalV2SystemFormsFormIdPatch$Params, context?: HttpContext): Observable<SystemFormsUpdate> {
    return this.updateSystemFormsInternalV2SystemFormsFormIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemFormsUpdate>): SystemFormsUpdate => r.body)
    );
  }

  /** Path part for operation `createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost()` */
  static readonly CreateSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPostPath = '/_internal/v2/system-forms/{formId}/versions';

  /**
   * Create System Forms New Version.
   *
   * Create a new version for an existing system form, with an option to set it as default.
   *
   * This endpoint creates a new system form version record for a given form. It first retrieves the existing
   * system form using formId, then updates the current versions by removing the default flag (if setDefault is True)
   * and marking them as not latest. A new version is created with the provided asset URL and timestamp, and if
   * setDefault is True, the new version is marked as default. The form data for the new version is also stored,
   * and the system form record is updated with the new version.
   *
   * Args:
   *     system_forms_version_in (schemas.SystemFormsVersionCreateNewVersion): The data required to create the new form version.
   *     org (Any): The organization details for permission verification.
   *     formId (str): The identifier of the system form for which a new version is being created.
   *     setDefault (bool, optional): If True, sets the new version as the default version. Defaults to False.
   *
   * Returns:
   *     schemas.SystemFormsVersion: The newly created system form version record.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Response(params: CreateSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFormsVersion>> {
    return createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create System Forms New Version.
   *
   * Create a new version for an existing system form, with an option to set it as default.
   *
   * This endpoint creates a new system form version record for a given form. It first retrieves the existing
   * system form using formId, then updates the current versions by removing the default flag (if setDefault is True)
   * and marking them as not latest. A new version is created with the provided asset URL and timestamp, and if
   * setDefault is True, the new version is marked as default. The form data for the new version is also stored,
   * and the system form record is updated with the new version.
   *
   * Args:
   *     system_forms_version_in (schemas.SystemFormsVersionCreateNewVersion): The data required to create the new form version.
   *     org (Any): The organization details for permission verification.
   *     formId (str): The identifier of the system form for which a new version is being created.
   *     setDefault (bool, optional): If True, sets the new version as the default version. Defaults to False.
   *
   * Returns:
   *     schemas.SystemFormsVersion: The newly created system form version record.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost(params: CreateSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Params, context?: HttpContext): Observable<SystemFormsVersion> {
    return this.createSystemFormsNewVersionInternalV2SystemFormsFormIdVersionsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemFormsVersion>): SystemFormsVersion => r.body)
    );
  }

  /** Path part for operation `setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch()` */
  static readonly SetFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatchPath = '/_internal/v2/system-forms/{formId}/versions/{versionId}';

  /**
   * Set Form Version As Default.
   *
   * Set a specific form version as the default version for a system form.
   *
   * This endpoint marks a specified system form version as the default by first validating that the form version
   * exists and is associated with the provided system form. It then updates all form versions of the system form,
   * removing the default flag from all versions, and finally sets the chosen version as default. The system form's
   * modification timestamp is updated accordingly.
   *
   * Args:
   *     formId (str): The identifier of the system form.
   *     versionId (str): The identifier of the form version to set as default.
   *     org (Any): The organization details for permission validation.
   *
   * Returns:
   *     schemas.SystemFormsVersion: The updated system form version record with the default flag set.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the specified form version does not exist or is not part of the system form.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Response(params: SetFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFormsVersion>> {
    return setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Set Form Version As Default.
   *
   * Set a specific form version as the default version for a system form.
   *
   * This endpoint marks a specified system form version as the default by first validating that the form version
   * exists and is associated with the provided system form. It then updates all form versions of the system form,
   * removing the default flag from all versions, and finally sets the chosen version as default. The system form's
   * modification timestamp is updated accordingly.
   *
   * Args:
   *     formId (str): The identifier of the system form.
   *     versionId (str): The identifier of the form version to set as default.
   *     org (Any): The organization details for permission validation.
   *
   * Returns:
   *     schemas.SystemFormsVersion: The updated system form version record with the default flag set.
   *
   * Raises:
   *     HTTPException: If the organization is not an agridence member.
   *     HTTPException: If the specified form version does not exist or is not part of the system form.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch(params: SetFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Params, context?: HttpContext): Observable<SystemFormsVersion> {
    return this.setFormVersionAsDefaultInternalV2SystemFormsFormIdVersionsVersionIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemFormsVersion>): SystemFormsVersion => r.body)
    );
  }

}
